<template>
    <v-app>
        <v-container class="px-0">
            <!-- Dialog de suppression -->
            <dialogDelete :title="$t('Administration.Categories.SubCategories.SubCategory')" :yes="confirmDelete"
                v-model="deleteDialog" max-width="600px" />

            <!-- Dialog d'édition -->
            <v-dialog v-model="editDialog">
                <v-card :width="800" class="pa-4" style="border-radius: 12px">
                    <v-card-title class="justify-content-center">
                        {{ $t('Administration.Categories.SubCategories.Edit') }}
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="editSubCategoryForm">
                            <!-- Subcategory Name -->
                            <v-label>
                                {{ $t('Administration.Categories.SubCategories.SubCategoryName') }}
                                <span class="required-field">*</span>
                            </v-label>
                            <v-text-field v-model="editSubCategoryData.name" outlined required hide-details="auto" />

                            <!-- Description -->
                            <v-label>{{ $t('Administration.Categories.SubCategories.Description') }}</v-label>
                            <v-text-field v-model="editSubCategoryData.description" outlined />

                            <!-- Parent Category -->
                            <v-label>{{ $t('Administration.Categories.SubCategories.CategoryParent') }}</v-label>
                            <v-select :items="categories" item-title="name" item-value="id"
                                v-model="editSubCategoryData.parent_category_id" outlined />

                            <!-- Logo Upload Section -->
                            <div class="row">
                                <!-- Current Logo Preview -->
                                <div class="col justify-content-center" style="max-width: 150px;">
                                    <v-img v-if="logoUrl" :src="logoUrl" class="nxmlogo" aspect-ratio="1"
                                        width="200"></v-img>
                                    <v-img v-else-if="editSubCategoryData.logoUrl" :src="editSubCategoryData.logoUrl"
                                        class="nxmlogo" aspect-ratio="1" width="200"></v-img>
                                    <v-img v-else src="@/assets/upload.png" class="nxmlogo" aspect-ratio="1"
                                        width="200"></v-img>
                                </div>

                                <!-- Logo Upload Button -->

                                <div class="col justify-content-center" style="max-width: 150px;">
                                    <div class="upload" @click="triggerFileInput">
                                        <svg class="pr-1 pb-1" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.53 13.53C11.38 13.68 11.19 13.75 11 13.75C10.81 13.75 10.62 13.68 10.47 13.53L9.75 12.81V17C9.75 17.41 9.41 17.75 9 17.75C8.59 17.75 8.25 17.41 8.25 17V12.81L7.53 13.53C7.24 13.82 6.76 13.82 6.47 13.53C6.18 13.24 6.18 12.76 6.47 12.47L8.47 10.47C8.54 10.41 8.61 10.36 8.69 10.32C8.71 10.31 8.74 10.3 8.76 10.29C8.82 10.27 8.88 10.26 8.95 10.25C8.98 10.25 9 10.25 9.03 10.25C9.11 10.25 9.19 10.27 9.27 10.3C9.28 10.3 9.28 10.3 9.29 10.3C9.37 10.33 9.45 10.39 9.51 10.45C9.52 10.46 9.53 10.46 9.53 10.47L11.53 12.47C11.82 12.76 11.82 13.24 11.53 13.53Z"
                                                fill="#ffffff" />
                                            <path
                                                d="M17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048Z"
                                                fill="#ffffff" />
                                        </svg>
                                        <button type="button" class="load">{{ $t('configuration.logo.uploadLogo')
                                            }}</button>
                                        <p v-if="editSubCategoryData.logoUrl" class="uploaded-file-name mt-2">
                                            {{ fileName }}
                                        </p>
                                    </div>
                                    <input ref="fileInput" type="file" accept="image/*" @change="onLogoChange"
                                        style="display: none;" />
                                </div>
                            </div>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="yes" :disabled="!editSubCategoryData.name" @click="saveEditedSubCategory">
                            {{ $t('Administration.Categories.Edit_Btn') }}
                        </v-btn>
                        <v-btn class="Cancel" @click="closeEditDialog">
                            {{ $t('Administration.Categories.SubCategories.Cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-table class="table-responsive" style="width: 100%">
                <thead>
                    <tr>
                        <th class="table_title text-left">{{
                            $t('Administration.Categories.SubCategories.SubCategoryName') }}</th>
                        <th class="table_title text-left">{{ $t('Administration.Categories.SubCategories.Description')
                            }}</th>
                        <th class="table_title text-left">{{ $t('Administration.Categories.SubCategories.Status') }}
                        </th>
                        <th class="table_title text-right">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="subcategory in filteredSubCategories" :key="subcategory.idCategory" class="Row"
                        @click="editSubCategory(subcategory)">
                        <td class="text-left">{{ subcategory.name }}</td>
                        <td class="text-left">{{ subcategory.description }}</td>
                        <td class="text-left">
                            <StatusButton :title="subcategory.is_active ? 'Active' : 'Inactive'"
                                :color="subcategory.is_active === 0 ? '#BDBDBD' : '#3BBAFF'" />
                        </td>
                        <td class="text-right">
                            <actions-menu :Id="subcategory.idCategory"
                                :status="subcategory.is_active ? 'Active' : 'Inactive'" :show-toggle-status="true"
                                v-model:dialogDelete="deleteDialog" v-model:dialogEdit="editDialog"
                                @edit="editSubCategory(subcategory)"
                                @update:dialogDelete="deleteSubCategory(subcategory)"
                                @toggle-status="toggleSubCategoryStatus(subcategory)" />
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </v-container>
    </v-app>
</template>

<script>
import StatusButton from "@/genericComponent/StatusButton.vue";
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import dialogDelete from "@/genericComponent/dialogDelete.vue";
import { getSubCategoriesById, UpdateCategoryStatus, deleteCategoryById, updateCategory, getCategory } from "@/api/index";

export default {
    name: "SubCategories",
    components: { StatusButton, actionsMenu, dialogDelete },
    props: {
        subCategoryId: null,
    },
    data() {
        return {
            searchTerm: '',
            fileName: '',
            categories: [],
            CategoryToDeleteId: null,
            subCategories: [],
            deleteDialog: false,
            editDialog: false,
            subCategoryToDelete: null,
            editSubCategoryData: { id: null, name: '', description: '', parent_category_id: this.$props.subCategoryId, logoUrl: null, LogoImage: null },
            logoUrl: null,
        };
    },
    created() {
        const categoryId = this.$props.subCategoryId;
        this.loadCategories();
        this.loadSubCategories(categoryId);
        this.emitter.on('event-test', this.handleGlobalSearch);
    },
    beforeUnmount() {
        this.emitter.off('event-test', this.handleGlobalSearch);
    },
    computed: {
        filteredSubCategories() {
            if (!this.searchTerm) {
                return this.subCategories;
            }
            const searchTermLower = this.searchTerm.toLowerCase();
            return this.subCategories.filter(subcategory =>
                subcategory.name.toLowerCase().includes(searchTermLower) ||
                subcategory.description.toLowerCase().includes(searchTermLower)
            );
        }
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleGlobalSearch(searchTerm) {
            this.searchTerm = searchTerm;
        },
        loadCategories() {
            getCategory()
                .then((response) => {
                    this.categories = response.data.paginatedResult.items.map((category) => ({
                        id: category.idCategory,
                        name: category.name,
                        description: category.description,
                        status: category.isActive === 1 ? 'Active' : 'Inactive',
                        parent_category_id: category.parentCategoryId,
                    }));
                })
                .catch((error) => {
                    console.error("Erreur lors de la récupération des catégories :", error);
                });
        },
        loadSubCategories(categoryId) {
            getSubCategoriesById(categoryId).then((resp) => {
                this.subCategories = resp.data.subCategoryList.map((category) => ({
                    idCategory: category.idCategory,
                    name: category.name,
                    description: category.description,
                    is_active: category.is_active === 1 ? 'Active' : 'Inactive',
                    parent_category_id: this.$props.subCategoryId,
                    logoUrl: category.logoUrl
                }));

            });
        },
        editSubCategory(subCategory) {
            this.editSubCategoryData = JSON.parse(JSON.stringify(subCategory));
            this.logoUrl = subCategory.logoUrl || null;
            if (subCategory.logoUrl) {
                const fileExtension = subCategory.logoUrl.split('.').pop();
                const categoryName = subCategory.name || "Unnamed";
                this.fileName = `${categoryName}.${fileExtension}`;
            } else {
                this.fileName = "";
            }
            this.editDialog = true;
        },
        onLogoChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.logoUrl = URL.createObjectURL(file);
                this.editSubCategoryData.LogoImage = file;
                const fileExtension = file.name.split('.').pop(); // Récupérer l'extension
                const categoryName = this.editSubCategoryData.name || "Unnamed"; // Utiliser le nom de la catégorie ou un placeholder
                this.fileName = `${categoryName}.${fileExtension}`; // Combiner le nom et l'extension
            }
        },
        saveEditedSubCategory() {
            const category = {
                CategoryId: this.editSubCategoryData.idCategory,
                name: this.editSubCategoryData.name,
                description: this.editSubCategoryData.description,
                parent_category_id: this.editSubCategoryData.parent_category_id,
                LogoImage: this.editSubCategoryData.LogoImage || null,
            };
            updateCategory(category)
                .then(() => {
                    this.closeEditDialog();
                    this.loadSubCategories(this.editSubCategoryData.parent_category_id);
                    this.ActiveSavedSnackBar();
                })
                .catch((error) => {
                    console.error(error);
                    this.ActiveWarningSnackBar();
                });
        },
        toggleSubCategoryStatus(subCategory) {
            subCategory.status = subCategory.is_active === 0 ? 'Inactive' : 'Active';
            const categoryData = {
                categoryId: subCategory.idCategory,
                state: subCategory.status === 'Active' ? 0 : 1,
            };
            UpdateCategoryStatus(categoryData)
                .then(() => {
                    subCategory.is_active = subCategory.is_active === 0 ? 1 : 0;
                    this.ActiveSavedSnackBar();
                })
                .catch((error) => {
                    console.error(error.msg);
                    this.ActiveWarningSnackBar();
                });
        },
        closeEditDialog() {
            this.editDialog = false;
        },
        deleteSubCategory(subCategory) {
            this.subCategoryToDelete = subCategory;
            this.deleteDialog = true;
            this.CategoryToDeleteId = subCategory.idCategory;
        },
        confirmDelete() {
            this.subCategories = this.subCategories.filter((sc) => sc.idCategory !== this.CategoryToDeleteId);
            deleteCategoryById(this.CategoryToDeleteId)
                .then((resp) => console.log(resp.data))
                .catch((error) => console.error(error.msg))
                .finally(() => {
                    this.closeDeleteDialog();
                    this.CategoryToDeleteId = null;
                });
        },
        closeDeleteDialog() {
            this.deleteDialog = false;
            this.subCategoryToDelete = null;
        },
        ActiveWarningSnackBar() {
            this.getParent("MainLayout").ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent("MainLayout").ActiveSavedSnackBar();
        },
        ActiveDeletedSnackBar() {
            this.getParent("MainLayout").ActiveDeletedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== "undefined") {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
    },
};
</script>

<style scoped>
.v-container {
    padding-top: 20px;
}

.v-divider {
    margin-bottom: 20px;
}

.table_title {
    font-weight: bold;
}

.Row:hover {
    background-color: #f2f2f2;
    cursor: pointer;
}

.required-field {
    color: red;
    margin-left: 3px;
    font-weight: bold;
}

.yes {
    background-color: #114ef7;
    font-weight: 600;
    color: #fff;
    margin-left: 300px;
}

.Cancel {
    font-weight: 500;
    color: #768da9;
    border: 1px solid #768da9;
}

.load {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 34px;
    color: #fff;
}

.upload {
    background-color: #3bbaff;
    width: 144px;
    height: 35px;
    border-radius: 6px;
    text-align: center;
}

.nxmlogo {
    width: 85px;
    height: 85px;
}

.custom-file-input {
    border-radius: 0%;
    max-width: 180px;
    text-align: center;
}

.uploaded-file-name {
    font-size: 14px;
    color: #3bbaff;
    word-break: break-word;
    /* Gérer les longs noms ou URL */
}

.mt-2 {
    margin-top: 8px;
}
</style>
